<template>
  <div
    :class="{
      'frisbuy-popup-image': true,
      'frisbuy-full-size': !popupSettings.image.cropToSquare,
    }"
  >
    <div class="frisbuy-image-area">
      <!-- TODO: make PositionBlockWrapper for not-square ShopTheLook's items -->
      <!-- <PositionBlockWrapper
        v-if="
          typeof popupImagePositionStyles !== 'undefined' &&
          Object.keys(popupImagePositionStyles).length > 0
        "
        :x="popupImagePositionStyles.x"
        :y="popupImagePositionStyles.y"
        :scale="popupImagePositionStyles.scale / 100"
      >
        <img
          v-if="imageSource.imageHighRes"
          :style="{ visibility: 'visible' }"
          ref="image"
          :src="imageSource.imageHighRes"
          @load="loadImageHandler"
          @error="errorImageHandler"
        />
      </PositionBlockWrapper> -->
      <div
        class="frisbuy-image-area__image-as-background"
        ref="photo"
        :style="{
          'background-image': `url(${imageSource.imageLowRes}), ${media.background}`,
        }"
      >
        <img
          v-if="imageSource.imageHighRes"
          ref="image"
          :src="getDomainSubstitute(imageSource.imageHighRes)"
          @load="loadImageHandler"
          @error="errorImageHandler"
        />
      </div>
    </div>

    <div
      v-if="
        media.linkList &&
        (popupSettings.showOneMarker || media.linkList.length > 1)
      "
      class="frisbuy-marker-area"
    >
      <template v-for="(link, index) in media.linkList">
        <a
          v-if="link.marker?.show"
          :key="link + index"
          :class="{
            'frisbuy-marker': true,
            'frisbuy-marker-hover': link.hover,
          }"
          :href="(!hideBuyButton(link) && link.link) ?? undefined"
          :target="
            Boolean(popupSettings.targetBlankLink) ? '_blank' : undefined
          "
          :style="markerStyle(link)"
          :title="link.sku.title"
          @click="linkClick(link, index)"
          @mouseenter="mouseOver(link, true)"
          @mouseleave="mouseOver(link, false)"
        >
          <span>{{ index + 1 }}</span>
        </a>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-marker {
  // В дизайне не маркеров. Параметра для скрытия также нет. Возможно, в будущем придется их использовать
  display: none;
}

.frisbuy-popup-image {
  .frisbuy-image-area {
    .frisbuy-image-area__image-as-background {
      background-position: top;
    }
  }
}
</style>

<script>
// Api
import { recoveryURL } from "@/api/api";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";
export default {
  data() {
    return {
      markerAreaValue: null,
    };
  },

  props: {
    post: {},
    media: {},
    settings: {},
  },

  computed: {
    popupImagePositionStyles() {
      if (!this.post.media || !this.post.media[0].view) {
        return {};
      }

      const { square } = this.post.media[0].view;

      if (!square) {
        return {};
      }

      return square;
    },

    popupSettings() {
      return this.settings.popup;
    },

    imageSource() {
      const { popupSettings } = this;

      return this.imageURL(this.media, true, popupSettings.image.highResImage);
    },

    markerArea() {
      return (
        this.markerAreaValue || {
          width: 100,
          height: 100,
        }
      );
    },
  },

  methods: {
    markerStyle(link) {
      return {
        top: `${Math.max(5, Math.min(95, link.marker.y))}%`,
        left: `${Math.max(5, Math.min(95, link.marker.x))}%`,
        color: this.popupSettings.image.colorNumber,
      };
    },

    loadImageHandler() {
      const { media, isRetina } = this;
      const { photo, image } = this.$refs;

      if (!photo || !image?.src) return;

      photo.style.backgroundImage = `url(${image.src})`;

      if (isRetina) {
        media.imageHighResolutionUrl = image.src;
      } else {
        media.imageUrl = image.src;
      }
    },

    getDomainSubstitute(srcUrl) {
      return DomainSubstitute(srcUrl);
    },

    errorImageHandler(e) {
      MediaCatcher(e, 2, widgetTypes.SHOP_THE_LOOK);
    },

    // errorImageHandler() {
    //   const { imageHighRes } = this.imageSource;

    //   let recoveryPath = recoveryURL(
    //     this.settings.srcDomain,
    //     this.post,
    //     this.post.media.indexOf(this.media),
    //     "image",
    //     this.isRetina,
    //     true
    //   );

    //   if (imageHighRes && !this.errorIndex) {
    //     recoveryPath += `&url=${encodeURIComponent(imageHighRes)}`;
    //   }

    //   if (++this.errorIndex > 2) return;

    //   this.$refs.image.src = recoveryPath;
    // },

    /*
      TODO: Rewrite the function.
      Function's parameters should not be changed
    */
    mouseOver(link, state) {
      link.hover = state;
    },

    linkClick(link) {
      const { post } = this;

      this.mouseOver(link, false);

      this.sendAnaliticEvent("ClickLink", {
        provPostId:
          this.post.instagramPost?.frisbuyId ??
          this.post.providerPost.frisbuyId,
        fbProduct: post.frisbuyPost.id,
        igCode: post.instagramPost.shortcode,
        link: link.link,
        linklabel: link.title,
        offer: link.sku.offerId,
      });

      // this.sendGATrack('ClickLink_gallery', `fbProduct${ this.post.frisbuyPost.id }_igCode${ this.post.instagramPost.shortcode }_link${ link.id }_linklabel${ link.title }_offer${ link.sku.offerId }`);
      // this.sendYAMetrika('FrisbuyClickLink', this.$parent.postIndex, index, this.post.media.indexOf(this.media));
    },

    setNarkerArea(imageURL) {
      const img = new Image();
      const area = {
        width: 100,
        height: 100,
      };

      img.onload = () => {
        if (
          img.height / img.width == 1 ||
          this.popupSettings.image.cropToSquare
        ) {
          this.markerAreaValue = null;
          return;
        }

        const maxProperty = img.height > img.width ? "height" : "width";
        const minValue = Math.min(img.height, img.width);
        const maxValue = Math.max(img.height, img.width);
        const ratio = maxValue / minValue;

        area[maxProperty] = (minValue * 100) / maxValue;
        area[maxProperty === "height" ? "width" : "height"] =
          ((minValue / ratio) * 100) / maxValue;

        this.markerAreaValue = area;
      };

      img.src = imageURL.imageLowRes;
    },
  },

  created() {
    const { imageSource, setNarkerArea } = this;

    setNarkerArea(imageSource);
  },

  watch: {
    imageSource(value) {
      const { setNarkerArea } = this;

      setNarkerArea(value);
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.frisbuy-popup-image {
  width: 100%;
  height: 100%;
  position: relative;

  overflow: hidden;

  &.frisbuy-full-size > div:first-child div {
    background-size: cover;
    display: block;
  }

  .frisbuy-image-area {
    padding-bottom: 100%;

    img {
      display: block;
      position: relative;
      visibility: hidden;
    }

    div {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  .frisbuy-marker-area {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
}
</style>
